/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Slug_ColInputs */

const en_admin_categories_slug_col = /** @type {(inputs: Admin_Categories_Slug_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug`)
};

/**
* | output |
* | --- |
* | "Slug" |
*
* @param {Admin_Categories_Slug_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_categories_slug_col = /** @type {((inputs?: Admin_Categories_Slug_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Slug_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_categories_slug_col(inputs)
});
export { admin_categories_slug_col as "admin.categories.slug_col" }